import { toast } from "sonner";

/**
 * Lightweight client-side CSV export for drill-down line items.
 * Opens directly in Excel/Sheets, no backend round-trip.
 *
 * @param {string} filename  e.g. "utilities_AllBranches_2026-01.csv"
 * @param {Array<object>} rows  array of record objects
 * @param {Array<{key:string,label:string,format?:(v:any,row:object)=>any}>} columns
 */
export function exportToCsv(filename, rows, columns) {
  if (!rows || rows.length === 0) return;
  const esc = (val) => {
    const s = val == null ? '' : String(val);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => esc(c.label)).join(',');
  const body = rows
    .map((row) => columns.map((c) => esc(c.format ? c.format(row[c.key], row) : row[c.key])).join(','))
    .join('\n');
  const csv = `${header}\n${body}`;
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Slugify a label into a filename-safe token. */
export function slug(s) {
  return String(s || '')
    .trim()
    .replace(/[^\w\u0600-\u06FF]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 60) || 'export';
}

/** Standard report columns used by the global Check & Export buttons. */
export const REPORT_EXPORT_COLS = [
  { key: 'counterparty', label: 'Counterparty' },
  { key: 'date', label: 'Date', format: (v) => String(v || '').slice(0, 10) },
  { key: 'amount', label: 'Amount' },
  { key: 'status', label: 'Status / Description' },
];

/** Shared check-&-export: validates rows, toasts a summary, then downloads CSV. */
export function handleExport(rows, filename, cols, label = 'records', amountKey = 'amount') {
  if (!rows?.length) { toast.info(`No ${label} to export`); return false; }
  const total = rows.reduce((s, x) => s + (Number(x?.[amountKey]) || 0), 0);
  toast.success(`Checked ${rows.length} ${label} · ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
  exportToCsv(filename, rows, cols);
  return true;
}
